
  export default {
    name: "blog",
    async asyncData({ req, store, route,app, error }) {
      let host = "";
      if (process.server) {
        host = req.headers.host + route.fullPath;
      } else {
        host = location.host + route.fullPath;
      }
      
      let articles = await app.$hyperBlog.getArticles('tags',route.params.tag,12);
      let metadata = await app.$hyperBlog.getCategories();
      // A tag exists only because an article carries it, so no articles means
      // no such tag -- do not serve an empty page with index,follow (#23545).
      // `undefined` is the API call failing, which must not become a 404.
      if (articles && !articles.length) {
        return error({ statusCode: 404, message: 'Δεν βρέθηκε το tag' });
      }
      return { articles,metadata };
    },
    head(){
      return {
        title: `Blog - ${this.$store.getters.store.eshop.name}`,
        script:[{
          hid: "ldBreadcrumbBlog",
          type: "application/ld+json",
          json: this.$hyperSeo.schemas(
            "breadcrumb",
            [{name:'Αρχική',url:'/'},{name:"Blog",url:"blog"},{name:this.$route.params.tag,url:this.$route.fullPath}]
          ),
        }],
        meta:[{
          hid: "robots",
          name: "robots",
          content:"index,follow",
        }]
      }
    },
    data() {
      return {
        articles: [],
        article: {},
        search: "",
        limit: 12,
        key: "q",
        total:0,
        categories:[],
        metadata:{}
      };
    },
    async mounted() {
      if (this.$route.params.q) {
        this.search = this.$route.params.q.split("=")[1];
        this.key = this.$route.params.q.split("=")[0];
        this.articles = await this.$hyperBlog.getArticles(this.key,this.search,16)
        return;
      }
    }
  };
  